// Live checkout-status listener for the cafemenu Razorpay payment flow.
// Backend writes live status to the SAME Firebase Realtime Database path
// the main Blue Tokai app already listens on for its own checkout
// (`FirebaseService.updateOrderStatus` in btc-backend_nov21, keyed by
// cartId) — this just reads it from the web.
//
// This is a best-effort enhancement on top of polling (getCafeMenuOrderStatus
// in OrderSummary.js), never a replacement: if the RTDB read is denied or
// the SDK fails to load, the polling path alone still drives the UI.
import { initializeApp, getApps } from "firebase/app";
import { getDatabase, ref, onValue, off } from "firebase/database";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyAYwMDqKwUr9J4-rSFnoBk-u8tGVPbP0F8",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "blue-tokai-coffee-appstage",
  databaseURL:
    process.env.REACT_APP_FIREBASE_DATABASE_URL ||
    "https://blue-tokai-coffee-appstage-default-rtdb.firebaseio.com",
};

// Mirrors FirebaseService.getCollectionName() on the backend — must stay in
// sync with whichever environment the backend this build talks to is in.
const PAYMENT_COLLECTION = process.env.REACT_APP_FIREBASE_PAYMENT_COLLECTION || "payments_staging";

let app = null;
let db = null;
const getDb = () => {
  if (db) return db;
  try {
    app = getApps()[0] || initializeApp(firebaseConfig);
    db = getDatabase(app);
    return db;
  } catch {
    return null;
  }
};

/**
 * Subscribes to `${PAYMENT_COLLECTION}/{cartId}` and calls `onUpdate(data)`
 * on every change. Returns an unsubscribe function — always safe to call,
 * even if the subscription never actually attached (denied rules, SDK
 * failure, etc).
 */
export function listenToCafeMenuOrderStatus(cartId, onUpdate) {
  if (!cartId) return () => {};
  const database = getDb();
  if (!database) return () => {};

  let cellRef;
  try {
    cellRef = ref(database, `${PAYMENT_COLLECTION}/${cartId}`);
    onValue(
      cellRef,
      (snapshot) => {
        const data = snapshot.val();
        if (data) onUpdate(data);
      },
      () => { /* permission-denied or offline — polling fallback keeps driving the UI */ }
    );
  } catch {
    return () => {};
  }

  return () => {
    try {
      if (cellRef) off(cellRef);
    } catch { /* ignore */ }
  };
}
